// Remembers where an unauthenticated user was headed so we can return them
// there after login. Stored in sessionStorage (not router state) because it
// must survive the OAuth full-page redirect and any /auth reload.
const KEY = 'auth:redirect-to';

// Same-origin guard: accept only internal paths with a single leading slash.
// Rejects protocol-relative (`//host`) and absolute (`scheme://...`) URLs, so
// the stored value can never become an open redirect to another domain.
const isSafeInternalPath = (path: string) => /^\/(?!\/)/.test(path);

// Don't bounce the user back into an auth screen after they authenticate.
const isAuthPath = (path: string) =>
  /^\/(auth|oauth|sign-up|forgot-password|onboarding)(\/|\?|$)/.test(path);

export const setRedirectAfterAuth = (path: string) => {
  if (isSafeInternalPath(path) && !isAuthPath(path)) {
    sessionStorage.setItem(KEY, path);
  }
};

export const consumeRedirectAfterAuth = (): string | null => {
  const path = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return path && isSafeInternalPath(path) ? path : null;
};
